import { Loader2 } from "lucide-react";
import React from "react";
import { cn } from "../../../lib/utils";
import {
  SPINNER_VARIANTS,
  SPINNER_CONFIG,
  SPINNER_BACKGROUNDS,
  SPINNER_TEXT_STYLES,
} from "./config";

type LoadingSpinnerProps = {
  title?: string;
  subtitle?: string;
  minHeight?: string;
  className?: string;
};

export const CustomLoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  title = "Loading...",
  subtitle = "Please wait.",
  minHeight = SPINNER_CONFIG.defaults.minHeight,
  className,
}) => {
  return (
    <div
      className={cn(
        SPINNER_VARIANTS.centered,
        SPINNER_CONFIG.defaults.padding,
        SPINNER_CONFIG.defaults.border,
        SPINNER_BACKGROUNDS.gradient,
        "m-1",
        minHeight,
        className,
      )}
    >
      <div className="relative">
        <div className={`absolute inset-0 rounded-full ${SPINNER_CONFIG.colors.bgPing} ${SPINNER_CONFIG.animations.ping} opacity-75`} />
        <Loader2 className={`relative ${SPINNER_CONFIG.sizes.icon.medium} ${SPINNER_CONFIG.colors.primaryDark} ${SPINNER_CONFIG.animations.spin}`} />
      </div>
      {title && <p className={`${SPINNER_CONFIG.spacing.titleMargin} ${SPINNER_TEXT_STYLES.title} ${SPINNER_CONFIG.colors.textDark}`}>{title}</p>}
      {subtitle && <p className={`${SPINNER_TEXT_STYLES.subtitle} ${SPINNER_CONFIG.colors.textSecondary}`}>{subtitle}</p>}
    </div>
  );
};
